import React, {useState} from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import WeeklyProductionFilters from "./weeklyProductionFilters";
import WeeklyProductionBody from "./weeklyProductionBody";
import LoadingIndicator from "../../../common/loadingIndicator";

/**
 * Weekly Production Report
 * @returns {JSX.Element}
 * @constructor
 */
const WeeklyProduction = () => {
    const [tableDataDiscipline1, setTableDataDiscipline1] = useState([]);
    const [tableDataDiscipline2, setTableDataDiscipline2] = useState([]);
    const [tableDataDiscipline3, setTableDataDiscipline3] = useState([]);
    const [tableDataDiscipline4, setTableDataDiscipline4] = useState([]);
    const [reportFilters, setReportFilters] = useState({
        isLoading: false,
        isSubmitted: false,
    });

    const reportFilterProps = {
        setReportFilters,
        setTableDataDiscipline1,
        setTableDataDiscipline2,
        setTableDataDiscipline3,
        setTableDataDiscipline4,
    };

    const reportBodyProps = {
        reportFilters,
        tableDataDiscipline1,
        tableDataDiscipline2,
        tableDataDiscipline3,
        tableDataDiscipline4,
    };

    return (
        <>
            <Breadcrumb title="Weekly Production" parent="Toolbox"/>
            <WeeklyProductionFilters {...reportFilterProps}/>
            <WeeklyProductionBody {...reportBodyProps}/>
            <LoadingIndicator isLoading={reportFilters.isLoading}/>
        </>
    );
}

export default WeeklyProduction;
